// Provide 1 to get A, 2 to get B etc.
import type { QuizQuestionResponse } from "@/api/quiz.ts";

export const LetterFromAnswer = (answerNum: number) => {
  // Return's 64, the next letter is (A - 65, B - 66 etc.)
  const keycode = "@".charCodeAt(0);

  return String.fromCharCode(keycode + answerNum);
};

export const AnswerToExplanation = (answerNum: number, question: QuizQuestionResponse) => {
  switch (answerNum) {
    case 1:
      return question.explanationA;
    case 2:
      return question.explanationB;
    case 3:
      return question.explanationC;
    case 4:
      return question.explanationD;

    default:
      return null;
  }
};
